<template>
  <div
      class="wrapper">
    <div style="flex: 1;">
      <h3 style="color: #2e7d32; margin-top: 0;">PROIECT FINANȚAT PRIN PS PAC 2023–2027</h3>
      <p style="margin: 0.5rem 0;">
        Acest proiect beneficiază de sprijin financiar din partea Uniunii Europene prin <strong>Fondul European Agricol pentru Dezvoltare Rurală (FEADR)</strong>.
      </p>
      <p style="margin: 0.5rem 0;">
        <strong>Obiectivul intervenției:</strong> Modernizarea și dezvoltarea unei exploatații agricole.
      </p>
      <a href="https://agriculture.ec.europa.eu/cap-my-country/cap-strategic-plans_ro" target="_blank" style="color: #0046c0; text-decoration: none;">
        Află mai multe despre FEADR
      </a>
    </div>
    <div>
      <img src="@/assets/madr-logo.svg" alt="MADR" height="80" style="display: block; margin-bottom: 0.5rem;">
      <div style="display: flex; justify-content: center; align-items: center; gap: 1rem;">
        <img src="https://upload.wikimedia.org/wikipedia/commons/b/b7/Flag_of_Europe.svg" alt="UE" width="80" style="display: block; margin-bottom: 0.5rem;">
        <img src="@/assets/afir-logo.jpg" alt="AFIR" width="80" style="display: block; margin-bottom: 0.5rem;">
      </div> <div style="text-align: center; font-weight: bold; color: #2e7d32;">PAC</div>
      <div style="text-align: center; font-size: 0.85rem;">Sprijin pentru viitori fermieri</div>
    </div>
  </div>
</template>
<style scoped>
.wrapper {
  border: 2px solid #4CAF50;
  border-radius: 8px;
  padding: 1rem;
  background-color: #f6fff1;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: sans-serif;
  margin: 10px;
  max-width: 600px;
  min-width: 600px;
}
</style>
<script setup lang="ts">
</script>
